module.exports = __webpack_public_path__ + "img/inspection@2x.da6f24f.jpg";